import constant from '../constants/contentConstant';

export const contentInitialState = {
    searchResult: {
        data: null,
        error: null,
        isLoading: false
    },
    paginateResult: {
        data: null,
        error: null,
        isLoading: false
    }
}

export function contentReducer(state, action) {

    switch (action.type) {

        case constant.SEARCH_REQUEST:
            return {
                ...state,
                searchResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.SEARCH_SUCCESS:
            return {
                ...state,
                searchResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.SEARCH_FAIL:
            return {
                ...state,
                searchResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

            case constant.PAGINATE_REQUEST:
            return {
                ...state,
                paginateResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.PAGINATE_SUCCESS:
            return {
                ...state,
                paginateResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.PAGINATE_FAIL:
            return {
                ...state,
                paginateResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        default:
            return state;
    }
}

export default contentReducer;
